import Progress from 'redux-progress';
import type { State as S } from 'model/State';

import {
  GET_CUSTOMER_BY_EMAIL,
  IS_MEMBER_OF_GROUP,
  IS_EMAIL,
  EXTERNAL,
  GET_PARTNER_NAME,
  GET_CONTACTS_FOR_ORGANISATION,
  GET_VALIDATE_COUNTRY_CHANGE,
  POST_ENABLE_DISABLE_MAIN_CONTACT,
  DELETE_CONTACT,
  ADD_NEW_PARTNER_CONTACT,
  PARTNER_EMAIL_CONFIG,
  UPDATE_PARTNER_EMAIL_CONFIG,
} from 'modules/mac/duck/actions/contact';

export type MACContactState = {
  deleteContact: any;
  mainContactEnableDisable: any;
  getCustomerByEmail: MACCustomersByEmailData;
  isMemberOfGroup: Progress<boolean>;
  isEmail: Progress<unknown>;
  external: Progress<unknown>;
  partnerName: object;
  contactsForOrganisation: object;
  validateCountryChange: object;
  addNewPartnerContact: any;
  partnerEmailConfig: any;
  updatePartnerEmailConfig: Progress<unknown>;
};

export type MACContactAction = {
  type:
    | typeof GET_CUSTOMER_BY_EMAIL
    | typeof IS_MEMBER_OF_GROUP
    | typeof IS_EMAIL
    | typeof EXTERNAL
    | typeof GET_CONTACTS_FOR_ORGANISATION
    | typeof GET_VALIDATE_COUNTRY_CHANGE
    | typeof POST_ENABLE_DISABLE_MAIN_CONTACT
    | typeof DELETE_CONTACT
    | typeof ADD_NEW_PARTNER_CONTACT
    | typeof GET_PARTNER_NAME
    | typeof PARTNER_EMAIL_CONFIG
    | typeof UPDATE_PARTNER_EMAIL_CONFIG;
  progress: Progress<unknown>;
  email: string;
  partnerId: string;
  country: string;
};

export type MACCurrentContactData = {
  contactDetails: {
    email: string;
    firstName: string;
    lastName: string;
    phone?: string;
  };
};

export type MACCustomersByEmailData = Record<string, object>;

export type MACPartnerDataType = {
  organisationDetails: { name: string; id?: number; partner?: boolean };
};

export type MACPartnerDataSelector = (
  state: S,
  partnerId: string | number,
) => { organisationDetails: { name: string } };

export type MACContactDetails = {
  contactDetails: {
    email: string;
    firstName: string;
    lastName: string;
  };
  organisationDetails: {
    id: string;
    discounts: any;
    name: string;
    expert: boolean;
    address1: string;
    address2: string;
    city: string;
    state: string;
    postcode: string;
    country: string;
  };
};

export type PartnerEmailTemplateConfig = {
  templateName: string;
  recipientType: RecipientType;
  recipientEmail: string | null;
  configurable: boolean | null;
};
export enum RecipientType {
  CUSTOMER = 'CUSTOMER',
  CUSTOMER_CC_PARTNER = 'CUSTOMER_CC_PARTNER',
  CUSTOMER_BCC_PARTNER = 'CUSTOMER_BCC_PARTNER',
  PARTNER = 'PARTNER',
  OTHER = 'OTHER',
}

export type MACContactSelector = (state: S, partnerEmail: string) => MACContactDetails;
